import RichText from "@/components/RichText";

// Repli tant que l'API n'a pas répondu (blocks === undefined, voir
// Home.jsx) — même logique que ServicesSection/ProcessSection.
const FALLBACK_BLOCKS = [
  { id: "fallback-1", props: { value: "10+", caption: "Années d'expérience" } },
  { id: "fallback-2", props: { value: "24h", caption: "Délai de réponse" } },
  { id: "fallback-3", props: { value: "100%", caption: "Satisfaction client" } },
];

export default function StatsBarSection({ blocks }) {
  const stats = (blocks === undefined ? FALLBACK_BLOCKS : blocks).filter((b) => b.enabled !== false);
  if (!stats.length) return null;
  return (
    <section className="bg-ink">
      <div
        className="max-w-[1240px] mx-auto px-6 md:px-10 py-10 grid gap-8 text-center"
        style={{ gridTemplateColumns: `repeat(${Math.min(stats.length, 4)}, minmax(0,1fr))` }}
      >
        {stats.map((block) => (
          <div key={block.id} data-block-key={block.id}>
            <p className="font-display font-semibold text-[28px] md:text-[34px] bg-clip-text text-transparent" style={{ backgroundImage: "linear-gradient(120deg, rgb(var(--c-gold)), rgb(var(--c-copper)))" }}>
              {block.props?.value}
            </p>
            <RichText as="p" className="text-[13px] text-white/60 mt-1.5" html={block.props?.caption} />
          </div>
        ))}
      </div>
    </section>
  );
}
